import { apiV2Root } from "consts";
import { useDataQueryParams } from "hooks/useDataQueryParams";

import { ADMIN_SCRIPTS_QUERY_KEY, type Script } from "./data/types";

/** Список скриптов наполнения БД со схемой параметров (для генерации формы). */
export const useScripts = () =>
  useDataQueryParams<Script[]>(ADMIN_SCRIPTS_QUERY_KEY, {}, apiV2Root);
